import { request } from '@umijs/max';
import { UploadVo, UrlListPayload, UrlSizeListPayload } from '../TenantTypings';

export namespace TenantFile {
  /**
   * @summary 文件url列表
   * @secure
   */
  export const urlList = async (data: UrlListPayload, params: { [key: string]: any } = {}) => {
    return request<UploadVo[]>(`/tenant/file/url/list`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 文件url列表 [size]
   * @secure
   */
  export const urlSizeList = async (
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    data: UrlSizeListPayload,
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo[]>(`/tenant/file/url/list/${size}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 文件url
   * @secure
   */
  export const url = async (id: number, params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/tenant/file/url/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 文件url [SIZE]
   * @secure
   */
  export const urlSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo>(`/tenant/file/url/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示文件
   * @secure
   */
  export const fileResponse = async (id: number, params: { [key: string]: any } = {}) => {
    return request<void>(`/tenant/file/response/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示文件 [SIZE]
   * @secure
   */
  export const fileResponseSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<void>(`/tenant/file/response/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 下载文件
   * @secure
   */
  export const fileDownload = async (id: number, params: { [key: string]: any } = {}) => {
    return request<void>(`/tenant/file/download/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 下载文件 [SIZE]
   * @secure
   */
  export const fileDownloadSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<void>(`/tenant/file/download/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };
}

export default TenantFile;

export const urlList = TenantFile.urlList;
export const urlSizeList = TenantFile.urlSizeList;
export const url = TenantFile.url;
export const urlSize = TenantFile.urlSize;
export const fileResponse = TenantFile.fileResponse;
export const fileResponseSize = TenantFile.fileResponseSize;
export const fileDownload = TenantFile.fileDownload;
export const fileDownloadSize = TenantFile.fileDownloadSize;
